import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('Google Analytics initialized');
  }
};

// Track page views
export const trackPageView = (path, title) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({
      hitType: 'pageview',
      page: path,
      title: title || document.title
    });
  }
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};

// Track document downloads
export const trackDocumentDownload = (documentName, documentType, planName) => {
  trackEvent('Document', 'Download', `${planName} - ${documentName}`, 1);
};

// Track plan views
export const trackPlanView = (planId, planName, companyName) => {
  trackEvent('Plan', 'View', `${companyName} - ${planName}`, 1);
};

// Track company page views
export const trackCompanyView = (companyId, companyName) => {
  trackEvent('Company', 'View', companyName, 1);
};

// Track comparison actions
export const trackComparison = (planNames) => {
  trackEvent('Comparison', 'Compare Plans', planNames.join(' vs '), planNames.length);
};

// Track PDF generation
export const trackPDFGeneration = (type, planNames) => {
  trackEvent('PDF', 'Generate', `${type}: ${planNames.join(', ')}`, 1);
};

// Track Ask AI usage
export const trackAskAI = (planName, question) => {
  trackEvent('AI', 'Ask Question', planName, 1);
};

// Track WhatsApp click
export const trackWhatsAppClick = (source) => {
  trackEvent('Contact', 'WhatsApp Click', source, 1);
};

// Track Call click
export const trackCallClick = (source) => {
  trackEvent('Contact', 'Call Click', source, 1);
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackDocumentDownload,
  trackPlanView,
  trackCompanyView,
  trackComparison,
  trackPDFGeneration,
  trackAskAI,
  trackWhatsAppClick,
  trackCallClick
};
